var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0214 18.703L16.4569 15.1385C19.4379 11.5033 19.2303 6.11755 15.8221 2.71179C12.2089 -0.903931 6.33972 -0.903931 2.71179 2.71179C-0.903931 6.33972 -0.903931 12.2089 2.71179 15.8221C6.11755 19.2303 11.5033 19.4379 15.1385 16.4569L18.703 20.0214C18.7811 20.0897 18.9056 20.0897 18.9716 20.0214L20.0214 18.9716C20.0897 18.9056 20.0897 18.7811 20.0214 18.703ZM14.5282 14.5282C11.6278 17.4261 6.93054 17.4261 4.03015 14.5282C1.1322 11.6278 1.1322 6.93054 4.03015 4.03015C6.93054 1.1322 11.6278 1.1322 14.5282 4.03015C17.4261 6.93054 17.4261 11.6278 14.5282 14.5282Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.00343f13daf1649556dd47f02054b357.svg";
export { ForwardRef as ReactComponent };